import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session'
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getBranchesLatest } from '../../store/actions';
import BranchToClassDDRow from '../BaseDropdownComponents/BranchToClassDDRow';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import * as XLSX from 'xlsx';
import { Button } from 'primereact/button';
import moment from 'moment';
import { Chart } from 'primereact/chart';

class IndividualApplicantTimelineReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportData: [],
            fullReportData: [],
            lazyParams: BasicLazyParams,
            totalRecords: 0,
            globalFilter: null,
            timelineStages: [],
            isLoading: false,
            selectedBranch: [],
            selectedBoard: [],
            selectedGrade: [],
            showAnalysis: false,
            chartData: null,
            chartOptions: null,
            activeView: 'report', // Default view is the report table
        };
        this.service = new Service();
        this.toast = null;
        this.stageColors = {
            'Enquiry': '#076EFF',
            'Application': '#819AF2',
            'Exam': '#C6D2FD',
            'Registration': '#962DFF',
            'Enrollment': '#D3ADF9'
        };
    }

    async componentDidMount() {
        this.props.getBranchesLatest(true);
        await this.fetchReportData();
        // Chart data is prepared in fetchReportData after data is loaded
    }

    processTimelineStages = (data) => {
        const stages = new Set();
        data.forEach(item => {
            item.timeline?.forEach(stage => {
                if (stage.stage !== 'Enquiry') {
                    stages.add(stage.stage);
                }
            });
        });

        const orderedStages = ['Application', 'Exam', 'Registration', 'Enrollment'];
        const sortedStages = orderedStages.filter(stage => stages.has(stage));

        this.setState({ timelineStages: sortedStages });
    };

    showMessage = (type, summary, detail) => {
        this.toast?.show({
            severity: type,
            summary: summary,
            detail: detail,
            life: 3000
        });
    };

    onPage = (event) => {
        this.setState((prevState) => ({
            lazyParams: {
                ...prevState.lazyParams,
                ...event
            }
        }), this.updatePaginatedData);
    };

    updatePaginatedData = () => {
        const { lazyParams, fullReportData, selectedBranch, selectedBoard, selectedGrade } = this.state;

        // Apply filters
        let filteredData = [...fullReportData];
        let branch = selectedBranch?.map(item => item).flat();
        let board = selectedBoard?.map(item => item).flat();
        let grade = selectedGrade?.map(item => item).flat();

        if (branch?.length > 0) {
            filteredData = filteredData.filter(item => branch.includes(item.branchId));
        }
        if (board?.length > 0) {
            filteredData = filteredData.filter(item => board.includes(item.boardId));
        }
        if (grade?.length > 0) {
            filteredData = filteredData.filter(item => grade.includes(item.gradeId));
        }

        // Paginate
        const startIndex = lazyParams.first;
        const endIndex = startIndex + lazyParams.rows;
        const paginatedData = filteredData.slice(startIndex, endIndex);

        this.setState({
            reportData: paginatedData,
            totalRecords: filteredData.length
        });
    };

    // When filters change, reset to first page and update paginated data
    filterReportData = () => {
        this.setState(
            prevState => ({
                lazyParams: { ...prevState.lazyParams, first: 0 }, // Reset to first page
            }),
            () => {
                this.updatePaginatedData();

                // Update chart data when filters change
                const { chartData, chartOptions } = this.prepareChartData();
                this.setState({
                    chartData: chartData,
                    chartOptions: chartOptions
                });
            }
        );
    };

    setDropdownValues = (values) => {
        this.setState({
            selectedBranch: values.branchId,
            selectedBoard: values.boardId,
            selectedGrade: values.classId
        }, this.filterReportData);
    };

    fetchReportData = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await this.service.post(`${baseUrlAdmin}/admissionReports/individualApplicantTimeline`, {
                academicYear: localStorage.getItem('userAcademicYear')
            }, true);

            if (response?.res?.status) {
                this.setState({
                    fullReportData: response.res.data,
                    reportData: response.res.data,
                    totalRecords: response.res.data.length
                }, () => {
                    this.processTimelineStages(response.res.data);
                    this.filterReportData();

                    // Prepare chart data when data is fetched
                    const { chartData, chartOptions } = this.prepareChartData();
                    this.setState({
                        chartData: chartData,
                        chartOptions: chartOptions
                    });
                });
                this.showMessage('success', 'Success', 'Report data fetched successfully');
            } else {
                this.showMessage('warn', 'Warning', response?.res?.message || 'No data found');
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
            this.showMessage('error', 'Error', 'Something went wrong while fetching data');
        } finally {
            this.setState({ isLoading: false });
        }
    };

    getTimelineValue = (rowData, stage) => {
        const timelineEntry = rowData.timeline?.find(item => item.stage === stage);
        return timelineEntry?.waitTimeInHours || '-';
    };

    exportToExcel = () => {
        const { reportData, timelineStages } = this.state;

        // Format data for export
        const exportData = reportData.map(item => {
            // Start with basic fields
            let rowData = {
                'Student Name': item.studentName,
                'Branch': item.branchName,
                'Board': item.boardName,
                'Grade': item.gradeName
            };

            // Add timeline stage columns
            timelineStages.forEach(stage => {
                const timelineEntry = item.timeline?.find(t => t.stage === stage);
                rowData[`${stage} (hrs)`] = timelineEntry?.waitTimeInHours || '-';
            });

            return rowData;
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Timeline Report");

        // Generate and download file
        XLSX.writeFile(workbook, `Applicant_Timeline_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    prepareChartData = () => {
        // Use filtered data (from the current data table) instead of all data
        const { fullReportData, selectedBranch, selectedBoard, selectedGrade } = this.state;
        
        // Apply the same filters as used in updatePaginatedData
        let filteredData = [...fullReportData];
        let branch = selectedBranch?.map(item => item).flat();
        let board = selectedBoard?.map(item => item).flat();
        let grade = selectedGrade?.map(item => item).flat();

        if (branch?.length > 0) {
            filteredData = filteredData.filter(item => branch.includes(item.branchId));
        }
        if (board?.length > 0) {
            filteredData = filteredData.filter(item => board.includes(item.boardId));
        }
        if (grade?.length > 0) {
            filteredData = filteredData.filter(item => grade.includes(item.gradeId));
        }

        // All stages including Enquiry
        const allStages = ['Enquiry', 'Application', 'Exam', 'Registration', 'Enrollment'];

        // Calculate SUM of wait time for each stage (not average)
        const stageTotals = {};
        const stageCounts = {};

        allStages.forEach(stage => {
            const stageEntries = filteredData
                .map(item => {
                    const entry = item.timeline?.find(t => t.stage === stage);
                    return entry && entry.waitTimeInHours ? parseFloat(entry.waitTimeInHours) : null;
                })
                .filter(hours => hours !== null && !isNaN(hours) && hours >= 0);

            if (stageEntries.length > 0) {
                // Calculate total hours for this stage
                const total = stageEntries.reduce((sum, hours) => sum + hours, 0);
                stageTotals[stage] = Math.round(total * 10) / 10; // Round to 1 decimal place
                stageCounts[stage] = stageEntries.length;
            } else {
                stageTotals[stage] = 0;
                stageCounts[stage] = 0;
            }
        });

        const dataValues = allStages.map(stage => stageTotals[stage]);

        const maxVal = Math.max(...dataValues);
        const yMax = maxVal <= 0 ? 10 :
            maxVal < 100 ? Math.ceil(maxVal * 1.3 / 10) * 10 : 
                Math.ceil(maxVal * 1.3 / 100) * 100; 

        const roundedYMax = Math.ceil(yMax / 100) * 100;

        let stepSize = Math.max(1, Math.round(roundedYMax / 5));

        if (stepSize > 1) {
            const magnitude = Math.pow(10, Math.floor(Math.log10(stepSize)));
            let normalized = stepSize / magnitude;

       
            if (normalized <= 1) normalized = 1;
            else if (normalized <= 2) normalized = 2;
            else if (normalized <= 5) normalized = 5;
            else normalized = 10;

            stepSize = normalized * magnitude;
        }

        const chartData = {
            labels: allStages,
            datasets: [
                {
                    label: 'Total Wait Time (Hours)',
                    data: dataValues,
                    fill: false,
                    borderColor: (context) => {
                        const index = context.dataIndex;

                   
                        if (index === allStages.length - 1) {
                            return this.stageColors[allStages[index]];
                        }

                        // Otherwise, use the color of the next stage for the line segment
                        return this.stageColors[allStages[index + 1]];
                    },
                    segment: {
                        // Color each line segment according to the next point's stage color
                        borderColor: (ctx) => {
                            // Get segment info
                            const index = ctx.p1DataIndex;
                            if (index < allStages.length - 1) {
                                return this.stageColors[allStages[index + 1]];
                            }
                            // For the last segment, use the last color
                            return this.stageColors[allStages[allStages.length - 1]];
                        }
                    },
                    stepped: true,
                    tension: 0, // Remove curve tension for true stepline effect
                    pointBackgroundColor: allStages.map(stage => this.stageColors[stage]),
                    pointBorderColor: '#FFFFFF', // White border around points for better visibility
                    pointBorderWidth: 3, // Thicker point border for better visibility
                    pointRadius: 10, // Larger points for better visibility
                    pointHoverRadius: 14, // Larger on hover
                    borderWidth: 3, // Thicker line for better visibility
                    lineTension: 0, // Ensure straight lines between points
                    // Add shadow effect to the line
                    shadowOffsetX: 0,
                    shadowOffsetY: 5,
                    shadowBlur: 15,
                    shadowColor: 'rgba(0, 0, 0, 0.3)',
                }
            ]
        };

        // Chart options based on ApexCharts stepline reference
        const chartOptions = {
            responsive: true, // Set to true to make it responsive within the container
            maintainAspectRatio: false,
            height: 600, // Fixed height in pixels
            chart: {
                type: 'line',
                height: 600, // Ensure consistent height
                toolbar: {
                    show: false // Hide toolbar for cleaner look
                }
            },
            stroke: {
                curve: 'stepline',
                width: 3, // Slightly thicker line for better visibility
                dashArray: [0], // Solid line for the main data
            },
            plugins: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    font: { size: 18, weight: 600, family: 'InterBold' }, // Larger title font
                    color: '#000000'
                },
                tooltip: {
                    callbacks: {
                        label: function (context) {
                            // Get the stage name and value
                            const stageName = context.label;
                            const totalHours = context.raw;
                            const count = stageCounts[stageName]; // Get count from stageCounts
                            
                            // Include count information in the tooltip
                            return [
                                `Total Hours: ${totalHours}`,
                                `Number of Students: ${count}`,
                                count > 0 ? `Average: ${Math.round((totalHours/count) * 10) / 10} hrs per student` : ''
                            ].filter(Boolean);
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    min: 0,
                    max: yMax,
                    title: {
                        display: true,
                        text: 'Hours',
                        font: {
                            size: 18, // Larger font for axis title
                            weight: 400,
                            family: 'InterRegular',
                            color: "#828898"
                        },
                        padding: 20 // More padding for title
                    },
                    ticks: {
                        stepSize: stepSize,
                        count: 7, // Reduced number of ticks for cleaner appearance
                        precision: 0, // Force integer ticks
                        font: {
                            size: 14, // Larger tick font size
                            weight: 500
                        },
                        padding: 10, // Add padding for ticks
                        callback: function (value) {
                            // Ensure we return only integers
                            return parseInt(value);
                        },
                        major: {
                            enabled: true // Enable major ticks
                        },
                        autoSkip: false // Don't skip ticks
                    },
                    grid: {
                        color: "#82889880",
                        borderDash: [4, 2], // Dashed lines as specified
                        drawBorder: true,
                        drawTicks: true, // Show tick marks
                        tickLength: 10, // Length of tick marks
                        lineWidth: 1.5, // Slightly thicker grid lines
                        z: 1 // Ensure grid lines are behind the data
                    },
                    border: {
                        width: 2, // Thicker axis line
                        color: "#000000" // Black axis line
                    }
                },
                x: {
                    display: false, // Hide x-axis labels as requested
                    grid: {
                        display: true, // Keep grid lines visible
                        borderDash: [4, 2], // Match the y-grid dashed style
                        color: "#82889880",
                        lineWidth: 1
                    },
                    ticks: {
                        display: false // Hide the ticks
                    }
                }
            }
        };

        return { chartData, chartOptions };
    };

    toggleView = () => {
        // If switching to analysis view, prepare chart data
        if (this.state.activeView === 'report') {
            const { chartData, chartOptions } = this.prepareChartData();
            this.setState({
                chartData: chartData,
                chartOptions: chartOptions,
                activeView: 'analysis'
            });
        } else {
            // Switch back to report view
            this.setState({ activeView: 'report' });
        }
    };

    renderChartLegend = () => {
        const allStages = ['Enquiry', 'Application', 'Exam', 'Registration', 'Enrollment'];

        return (
            <div className="flex flex-column flex-wrap gap-3 justify-content-center mt-3">
                {allStages.map(stage => (
                    <div key={stage} className="flex align-items-center gap-2">
                        <div style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            backgroundColor: this.stageColors[stage]
                        }} />
                        <span>{stage}</span>
                    </div>
                ))}
            </div>
        );
    };

    render() {
        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };
        return (
            <div style={containerStyle} className=' m-2'>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                <div className="card filters-card mt-1 pt-0">
                    <BranchToClassDDRow
                        setValues={this.setDropdownValues}
                        showTooltip={false}
                        tooltip={null}
                        tooltipOptions={{ disabled: true }}
                    />

                    <div className='flex justify-content-end align-items-center gap-2 order-1 ml-auto mt-5'>
                        <Button
                            label="Download Report"
                            onClick={this.exportToExcel}
                            style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                        />
                        {this.state.activeView === 'report' ? (
                            <Button
                                label="View Analysis"
                                className="p-button-primary"
                                onClick={this.toggleView}
                                style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff" }}
                            />
                        ) : (
                            <Button
                                label="View Report"
                                className="p-button-primary"
                                onClick={this.toggleView}
                                style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff" }}
                            />
                        )}
                    </div>

                </div>

                {this.state.activeView === 'report' ? (
                    <div className="datatable-report-demo mx-2">
                        <DataTable
                            value={this.state.reportData}
                            responsiveLayout="scroll"
                            dataKey="id"
                            paginator
                            lazy
                            onPage={this.onPage}
                            resizableColumns
                            first={this.state.lazyParams.first}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            rowClassName={() => 'table-row-style'}
                        >
                            <Column field='studentName' header='Student Name' />
                            <Column field="branchName" header="Branch" />
                            <Column field="boardName" header="Board" />
                            <Column field="gradeName" header="Grade" />
                            {this.state.timelineStages.map(stage => (
                                <Column
                                    key={stage}
                                    field={stage.toLowerCase()}
                                    header={`${stage} (hrs)`}
                                    body={(rowData) => this.getTimelineValue(rowData, stage)}
                                />
                            ))}
                        </DataTable>
                    </div>
                ) : (
                    <div className="analysis-chart-container card mx-2 mt-4 p-4 mb-5">
                        <h2 className=" mb-4 text-center" style={{ fontWeight: "700" ,color:"#1E1B39", fontFamily:"Inter"}}>Total Wait Time By Stage</h2>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            {this.state.chartData && (
                                <Chart
                                    type="line"
                                    data={this.state.chartData}
                                    options={this.state.chartOptions}
                                    style={{
                                        height: '400px',
                                        width: '50%',
                                        maxWidth: '1000px'
                                    }}
                                />
                            )}
                            <div className="chart-legend" style={{ width: '20%' }}>
                                {this.renderChartLegend()}
                            </div>
                        </div>
                    </div>
                )}

                {this.state.isLoading && <LoadingComponent />}
            </div >
        )
    }
}
const mapStatesToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(IndividualApplicantTimelineReport)));